import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { setLoginModalOpen } from '../../Actions/Login.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import LoginMode from '../../Types/LoginMode';
import LoginContainer from './LoginContainer';
import SideMenu from '../SideMenu/SideMenu';
import clsx from 'clsx';

const LoginModal = () => {
  const { modalOpen, loginMode, isLoading } = useTypedSelector(
    (state) => state.login
  );
  const dispatch = useDispatch();
  const disableClosing = useMemo(
    () =>
      loginMode == LoginMode.ChangePassword ||
      loginMode == LoginMode.SelectOrganization,
    [loginMode]
  );

  return (
    <SideMenu
      className="z-[60] rounded"
      id="login-modal"
      open={modalOpen}
      onClosed={() => dispatch(setLoginModalOpen(false))}
      disableClosing={disableClosing || isLoading}
    >
      <div className="px-10 pb-10">
        <LoginContainer useH1={false} />
      </div>
    </SideMenu>
  );
};

export default LoginModal;
